import appInsights from "../azureAppInsights";

declare global {
  interface Window {
    // GTM dataLayer: consent updates and the Google Ads lead conversion
    dataLayer: Record<string, unknown>[];
  }
}

export type BehaviourEvent =
  | "Lander Page View"
  | "Pension Details Start"
  | "Pension Details Complete"
  | "Personal Details Start"
  | "Personal Details Complete"
  | "Address Complete"
  | "Lead With Email"
  | "Lead With Phone"
  | "Lead With Address"
  | "Appointment Booked"
  | "Adhoc Appointment Booked"
  | "Lander Error"
  // Page-numbered form steps (cost of delay calculator): page 1 details, page 2 assumptions, page 3 booking details.
  | "Started Form Page 1"
  | "Completed Form Page 1"
  | "Started Form Page 2"
  | "Completed Form Page 2"
  | "Started Form Page 3"
  | "Completed Form Page 3"
  // After quotes: a flow, not a funnel. View events carry `from`, the step the visitor came from.
  | "Quotes Received"
  | "Quotes Viewed"
  | "Quote Detail Viewed"
  | "Booking Page Viewed"
  | "Registration Viewed"
  | "Existing Account Found"
  | "Account Created"
  | "Sign In Link Sent"
  | "Signed In";

type JourneyProperties = {
  lander: string;
  source: string;
  utm_campaign: string;
};

let journey: JourneyProperties | null = null;

function isDebug(): boolean {
  try {
    return localStorage.getItem("debugTracking") === "true";
  } catch {
    return false;
  }
}

// The lander a visit started on, for the rest of the page load; held in memory only, never stored on the device.
// Visits are stitched by App Insights' own session_Id.
export function startBehaviourJourney({ lander, source }: { lander: string; source?: string }) {
  if (journey?.lander === lander) return;
  const params = new URLSearchParams(window.location.search);
  journey = {
    lander,
    source: source || "direct",
    utm_campaign: params.get("utm_campaign") || params.get("vt_campaign") || "",
  };
}

// Sends every occurrence to App Insights; funnels count one per session. Nothing is sent outside a tracked lander visit.
export function trackBehaviourEvent(name: BehaviourEvent, properties: Record<string, string> = {}) {
  if (!journey) return;
  const payload = { ...journey, ...properties };
  if (isDebug()) console.log("[AppInsights:event]", name, payload);
  try {
    appInsights.trackEvent({ name }, payload);
  } catch {
    // Telemetry must never break the page.
  }
}

// An untracked lander ends any tracked visit from earlier in the page load, so its events aren't sent under that lander.
export function endBehaviourJourney() {
  journey = null;
}

export function resetBehaviourJourneyForTests() {
  journey = null;
}
